/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";

import { PurposedButtonProps } from "./types";
import { useTheme } from "../../../../config/emotion";
import EwaButton2 from "./EwaButton/EwaButton2";
import { labellessButtonCss } from "./styles";

const AddRowButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.save}
      tooltip={
        !props.label
          ? formatMessage({ id: "template_builder.add_row" })
          : undefined
      }
      css={!props.label && labellessButtonCss}
      iconName="playlist_add"
      dataCy="add-row-record-button"
      {...props}
    />
  );
};

export default AddRowButton;
